import { Box } from '@mui/material';

import { AppIcon } from '~components/shared/app-icon/app-icon';
import { DRAWERS } from '~components/shared/drawer/constants';

import { useSpecificDrawer } from '~hooks/use-specific-drawer';

import { ReactComponent as BellIcon } from '~assets/icons/icon-bell.svg';

export const Notifications = () => {
  const { openSpecificDrawer } = useSpecificDrawer();

  return (
    <Box
      sx={{
        padding: 0.5,
        borderRadius: '50%',
        backgroundColor: 'primary.10',
        color: 'primary.100',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '&:hover': {
          backgroundColor: 'primary.15',
          color: 'primary.125',
        },
      }}
      role={'button'}
      onClick={() =>
        openSpecificDrawer({
          drawerId: DRAWERS.NOTIFICATIONS_DRAWER,
        })
      }
    >
      <AppIcon component={BellIcon} />
    </Box>
  );
};
